  // coffeelint: disable
angular.module('gym.field', ['model']).factory('Field', [
  'Model',
  function(Model) {
    var Field;
    return Field = (function() {
      class Field extends Model {
        label() {
          return this.attributes.label;
        }

        name() {
          return this.attributes.name;
        }

        type() {
          return this.attributes.type;
        }

        formId() {
          return this.form().id();
        }

        params() {
          var base;
          return (base = this.attributes).params || (base.params = {});
        }

      };

      Field.param = 'field';

      Field.prototype.form = Field.prototype.parent;

      return Field;

    }).call(this);
  }
]).directive('textNumber', [
  function() {
    return {
      require: '^ngModel',
      restrict: 'A',
      link: function(scope,
  element,
  attrs,
  modelCtrl) {
        return modelCtrl.$parsers.push(function(inputValue) {
          var transformedInput;
          transformedInput = inputValue.replace(/[^\d.-]/g,
  '');
          if (transformedInput !== inputValue) {
            modelCtrl.$setViewValue(transformedInput);
            modelCtrl.$render();
          }
          return transformedInput;
        });
      }
    };
  }
]).directive('eventToStr', [
  'formatDateTimeFilter',
  function(formatDateTime) {
    return {
      require: '^ngModel',
      restrict: 'A',
      link: function(scope,
  elm,
  attrs,
  ctrl) {
        return ctrl.$formatters.unshift(function(model) {
          if (!model) {
            return void 0;
          }
          return `${model.title} - ${formatDateTime(model.start)}`;
        });
      }
    };
  }
]);

// coffeelint: enable
